import CheckIcon from '@material-ui/icons/Check';
import classnames from 'classnames';
import React from 'react';
import { Tooltip } from 'swag-client-common/components/info/tooltip/tooltip';
import { popperProps } from 'swag-client-common/components/partials/header-icons/header-icons';
import { Placement } from 'swag-client-common/constants';
import { pluralize } from 'swag-common/utils/strings';
import infoImage from 'assets/svg/information.svg';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from './time-table.scss';
export const TimeTable = ({
  onChange,
  prodTime,
  timeList,
  editAvailable,
  isBox,
  isLimitedEdition,
  superSpeedMethod,
  tableClassName
}) => /*#__PURE__*/React.createElement("table", {
  className: classnames(classes.table, tableClassName),
  "data-table": "ProductionTime"
}, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null, "Service"), /*#__PURE__*/React.createElement("th", null, "Time"), /*#__PURE__*/React.createElement("th", null, "Cost"))), /*#__PURE__*/React.createElement("tbody", null, timeList.map(({
  name,
  cost,
  time,
  prodTimeIndex,
  showSuperSpeedEmbellishmentMethodTooltip
}) => /*#__PURE__*/React.createElement("tr", {
  key: name,
  className: classnames({
    [classes.active]: prodTime === prodTimeIndex && editAvailable,
    [classes.interactive]: editAvailable
  }),
  onClick: () => onChange(prodTimeIndex),
  tabIndex: editAvailable ? 0 : -1,
  onKeyDown: e => handleOnEnterPressed(e, () => onChange(prodTimeIndex)),
  "aria-label": name
}, /*#__PURE__*/React.createElement("td", {
  className: classnames(classes.selectField, {
    [classes.orangeCheck]: isLimitedEdition
  })
}, /*#__PURE__*/React.createElement(CheckIcon, null)), /*#__PURE__*/React.createElement("td", {
  "data-cell": "Name",
  className: classes.name
}, name, showSuperSpeedEmbellishmentMethodTooltip && /*#__PURE__*/React.createElement(Tooltip, {
  title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classes.methodName
  }, superSpeedMethod.name), "\xA0 is the only decorating method available for this product to meet the Super Speed production timeline."),
  mode: "light",
  placement: Placement.RIGHT,
  className: classes.tooltip,
  PopperProps: popperProps
}, /*#__PURE__*/React.createElement("img", {
  src: infoImage,
  alt: "Info image"
}))), /*#__PURE__*/React.createElement("td", {
  "data-cell-days": time
}, pluralize(time, 'Business day', 's')), /*#__PURE__*/React.createElement("td", {
  "data-cell": "Cost"
}, cost === 0 ? 'Free' : `${(cost * 100).toFixed(0)}%`, isBox && cost !== 0 && ' or less')))));